import {BasePage} from './base';

import {PopupUtils} from '../tools/popup';


import '@fontsource/montserrat';
import '@styles/common/_header.scss';
import '@styles/index.scss';
import '@styles/menu.scss';
import '@styles/modal.scss';
import '@styles/btns.scss';
import '@styles/common/_forms.scss';


import FormBase from '../forms/base.js';
import ymaps from 'ymaps';

import '@styles/product-slider.scss';

import Swiper from 'swiper';
import {Navigation, Pagination, Autoplay} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';


export class IndexPage extends BasePage
{
    constructor(element)
    {
        super();
        this.title = '';
        this.element = element;
    }
}

// Пример использования
document.addEventListener('DOMContentLoaded', () => {

    const productSliderEl = document.querySelector('.product-slider');
    if (productSliderEl) {
        const swiperInst = new Swiper(productSliderEl, {
            modules: [Navigation, Pagination, Autoplay],
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            navigation: {
                prevEl: '.product-slider__nav .swiper-button-prev',
                nextEl: '.product-slider__nav .swiper-button-next',
            },
            pagination: {
                el: '.product-slider__pagination',
                type: 'custom',
                renderCustom(swiper, current, total) {
                    let html = '';
                    for (let i = 0; i < total; i++) {
                        const slide = swiper.slides[i];
                        const title = slide?.dataset.title || '';
                        // const num = String(i + 1).padStart(2, '0');
                        const active = i === current - 1 ? ' active' : '';
                        html += `<button type="button" class="product-slider__pagination-btn${active}" data-slide="${i}">${title}</button>`;
                    }
                    return html;
                },
            },
            on: {
                slideChange(swiper) {
                    const pagEl = swiper.pagination?.el;
                    if (!pagEl) return;
                    const btns = pagEl.querySelectorAll('.product-slider__pagination-btn');
                    btns.forEach((btn, i) => btn.classList.toggle('active', i === swiper.realIndex));
                },
            },
        });

        const paginationEl = document.querySelector('.product-slider__pagination');
        if (paginationEl) {
            paginationEl.addEventListener('click', (e) => {
                const btn = e.target.closest('.product-slider__pagination-btn');
                if (btn && swiperInst) {
                    swiperInst.slideToLoop(Number(btn.dataset.slide));
                }
            });
        }
    }

    const formsList = ['main-form'];

    formsList.forEach(formId => {
        const element = document.getElementById(formId);
        if (element) {
            const form = new FormBase(element, {
                endpoint: 'https://gearhive.ru/ajax/forms.php',
            });
            window.forms = window.forms || {};
            window.forms[formId] = form;
        } else {
            console.warn(`Element with id "${formId}" not found`);
        }
    });

    //
    let previews = document.querySelectorAll('.preview-card-custom');
    previews.forEach((item) => {
        item.addEventListener('click', function(e) {
            const urlToOpen = e.currentTarget.getAttribute('data-url');
            const titleCard = e.currentTarget.querySelectorAll('h3')[0].innerText;

            PopupUtils.loadHtml(urlToOpen, {
                title: titleCard,
                type: 'content',
                size: 'xl',
                buttons: [],
                onLoadSuccess: (html) => {
                    console.log('HTML загружен, длина:', html.length);
                },
                onLoadError: (error) => {
                    console.error('Ошибка:', error);
                },
            });
        });
    });


    let links = document.querySelectorAll('.link-info');
    links.forEach((item) => {

        item.addEventListener('click', function(e) {
            e.preventDefault();
            const urlToOpen = e.currentTarget.getAttribute('data-url');
            const titleCard = e.currentTarget.getAttribute('data-title');

            PopupUtils.loadHtml(urlToOpen, {
                title: titleCard,
                type: 'content',
                size: 'xl',
                buttons: [],
                onLoadSuccess: (html) => {
                    console.log('HTML загружен, длина:', html.length);
                },
                onLoadError: (error) => {
                    console.error('Ошибка:', error);
                },
            });
        });
    });

    // Анимация на странице
    (function() {
        // Плавное появление элементов при прокрутке
        const fadeElements = document.querySelectorAll('.fade-up');

        function checkVisibility()
        {
            fadeElements.forEach(el => {
                const rect = el.getBoundingClientRect();
                const windowHeight = window.innerHeight;
                // Если элемент появляется в зоне видимости - добавляем класс visible
                if (rect.top < windowHeight - 120) {
                    el.classList.add('visible');
                }
            });
        }

        // Проверяем при загрузке и при скролле
        window.addEventListener('load', checkVisibility);
        window.addEventListener('scroll', checkVisibility);
        // Дополнительно для ресайза
        window.addEventListener('resize', checkVisibility);

        // Убедимся, что все fade-up элементы изначально не видны (но стили уже заданы)
        // Принудительно вызываем первый раз чуть позже для уверенности
        // setTimeout(checkVisibility, 200);
    })();


    (function() {
        const stickyHeader = document.getElementById('stickySectionHeader');
        const stickyTitle = document.getElementById('stickyTitle');
        const stickyBadge = document.getElementById('stickyBadge');
        const stickyButtons = document.getElementById('stickyButtons');
        // Находим все секции с нужным классом
        const sections = document.querySelectorAll('.container-item');

        // Для каждой секции извлекаем заголовок
        const sectionsData = [];

        sections.forEach((section, index) => {
            // Ищем заголовок внутри секции
            let title = '';
            let badge = '';
            let productData = {};

            // Пробуем найти h2
            const h2 = section.querySelector('h2');
            if (h2) {
                title = h2.textContent.trim();
            }

            // Если нет h2, ищем h3
            if (!title) {
                const h3 = section.querySelector('h3');
                if (h3) {
                    title = h3.textContent.trim();
                }
            }

            // Если всё ещё нет, берём первый текст из .section-content или id секции
            if (!title) {
                const sectionContent = section.querySelector('.section-content');
                if (sectionContent) {
                    const firstHeading = sectionContent.querySelector('h2, h3, h4');
                    if (firstHeading) {
                        title = firstHeading.textContent.trim();
                    }
                }
            }

            // Если совсем пусто, берём id или номер
            if (!title) {
               //  title = section.id ? section.id.toUpperCase() : `Раздел ${index + 1}`;
            }

            // Бейдж (может быть из id или первый абзац)
            badge = section.id ? section.id : `секция ${index + 1}`;

            productData.id = 125796;


            const buyButton = document.createElement('button');
            buyButton.className = 'col-12 btn btn-primary-gear shadow-sm';
           // buyButton.setAttribute('data-buy-id', '125796');
            buyButton.setAttribute('data-target', 'popup');
            buyButton.textContent = 'Купить';

            // Добавить обработчик
            buyButton.addEventListener('click', function(e) {
                e.preventDefault();

                let form = document.getElementById('form-buy');
                let HtmlContent = form.innerHTML;

                const productId = e.currentTarget.getAttribute('data-buy-id');


                PopupUtils.loadHtmlContent(HtmlContent, {
                    title: 'Заказать товары',
                    type: 'content',
                    size: 'xl',
                    buttons: [],
                    onLoadSuccess: (html, fromCache) => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(html, 'text/html');

                        // Находим все формы в загруженном HTML
                        const forms = doc.querySelectorAll('form');

                        if (forms.length === 0) {
                            console.warn('Формы не найдены в загруженном HTML');
                            return;
                        }

                        // Инициализируем каждую форму
                        forms.forEach((formElement, index) => {
                            const formId = formElement.id = `form-${index}`
                            const initForms = () => {
                                const domForms = document.querySelectorAll('.modal-body form');

                                if (domForms.length === 0) {
                                    console.log('Формы еще не в DOM, повторная проверка...');
                                    setTimeout(initForms, 300);
                                    return;
                                }

                                domForms.forEach((domForm, index) => {
                                    // Присваиваем ID, если его нет
                                    if (!domForm.id) {
                                        domForm.id = `form-${index}`;
                                    }

                                    const formId = domForm.id;

                                    try {
                                        const form = new FormBase(domForm, {
                                            endpoint: 'https://gearhive.ru/ajax/forms.php',
                                        });

                                        window.forms = window.forms || {};
                                        window.forms[formId] = form;

                                        console.log(`Форма "${formId}" успешно инициализирована`);
                                    } catch (error) {
                                        console.error(`Ошибка инициализации формы "${formId}":`, error);
                                    }
                                });
                            };

                            // Начинаем инициализацию с небольшой задержкой
                            setTimeout(initForms, 200);
                        });

                    },
                    onLoadError: (error) => {
                        console.error('Ошибка:', error);
                    },
                });
            });

             // productData.buyButton = buyButton;

            sectionsData.push({
                product: productData,
                element: section,
                title: '',
                badge: badge,
                index: index,
            });
        });

        // Функция определения текущей активной секции
        function getActiveSection()
        {
            const scrollPosition = window.scrollY + 150; // Отступ от верха
            const navHeight = document.querySelector('.navbar')?.offsetHeight || 0;
            const adjustedPosition = window.scrollY + navHeight + 80;

            let activeSection = null;

            for (let i = 0; i < sectionsData.length; i++) {
                const section = sectionsData[i].element;
                const rect = section.getBoundingClientRect();
                const sectionTop = rect.top + window.scrollY;
                const sectionBottom = sectionTop + rect.height;

                // Если скролл находится в пределах секции
                if (window.scrollY + navHeight + 50 >= sectionTop &&
                    window.scrollY + navHeight + 50 < sectionBottom) {
                    activeSection = sectionsData[i];
                    break;
                }
            }

            // Если не нашли, берём ближайшую сверху
            if (!activeSection && sectionsData.length > 0) {
                for (let i = sectionsData.length - 1; i >= 0; i--) {
                    const section = sectionsData[i].element;
                    const rect = section.getBoundingClientRect();
                    const sectionTop = rect.top + window.scrollY;
                    if (window.scrollY + navHeight + 50 >= sectionTop) {
                        activeSection = sectionsData[i];
                        break;
                    }
                }
            }

            return activeSection;
        }

        // Функция проверки видимости и обновления прилипающего заголовка
        function updateStickyHeader()
        {
            const activeSection = getActiveSection();

            if (!activeSection) {
                stickyHeader.classList.remove('visible');
                document.body.classList.remove('sticky-active');
                return;
            }

            const sectionElement = activeSection.element;
            const sectionProduct = activeSection.product;
            const rect = sectionElement.getBoundingClientRect();
            const navHeight = document.querySelector('.navbar')?.offsetHeight || 0;


            // Если секция ушла за верхний край экрана (немного за навбар)
            if (rect.top < navHeight + 30) {
                // Обновляем заголовок
                // stickyTitle.textContent = activeSection.title;
                if (stickyBadge) {
                     //stickyBadge.textContent = activeSection.badge;
                }

                stickyButtons.innerHTML = ``;
                // stickyButtons.appendChild(sectionProduct.buyButton);

                stickyHeader.classList.add('visible');
                document.body.classList.add('sticky-active');
            } else {
                stickyHeader.classList.remove('visible');
                document.body.classList.remove('sticky-active');
            }
        }

        function checkAndUpdate()
        {
            updateStickyHeader();
        }

        // Запускаем слушатели
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                window.addEventListener('scroll', checkAndUpdate);
                window.addEventListener('resize', checkAndUpdate);
                checkAndUpdate();
            });
        } else {
            window.addEventListener('scroll', checkAndUpdate);
            window.addEventListener('resize', checkAndUpdate);
            checkAndUpdate();
        }
    })();

    //

    // DOM элементы
    const sideMenu = document.getElementById('sideMenu');
    const overlay = document.getElementById('menuOverlay');
    const openBtn = document.getElementById('openMenuBtn');
    const openBtnSecond = document.getElementById('openBtnSecond');
    const closeBtn = document.getElementById('closeMenuBtn');
    const navLinks = document.querySelectorAll('.nav-link-custom');
    // const contentArea = document.getElementById('dynamicContent');

    // Функция открытия меню
    function openMenu()
    {
        sideMenu.classList.add('open');
        overlay.classList.add('show');
        document.body.style.overflow = 'hidden'; // предотвращаем скролл фона
    }

    // Функция закрытия меню
    function closeMenu()
    {
        sideMenu.classList.remove('open');
        overlay.classList.remove('show');
        document.body.style.overflow = '';
    }

    // Закрытие по клику на оверлей
    overlay.addEventListener('click', closeMenu);

    // Открытие по кнопке-бургер
    openBtn.addEventListener('click', openMenu);
    openBtnSecond.addEventListener('click', openMenu);

    // Закрытие по крестику
    closeBtn.addEventListener('click', closeMenu);

    // Дополнительно: закрытие по клавише ESC
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && sideMenu.classList.contains('open')) {
            closeMenu();
        }
    });


    let smoothScrollActive = false;
    let lastActiveIndex = null;

    function scrollToSection(pageId, offset = 100)
    {

        const targetElement = document.getElementById(pageId);

        if (targetElement) {
            smoothScrollActive = true;
            const fixedOffset = document.querySelector('.navbar')?.offsetHeight || offset;
            const elementPosition = targetElement.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - fixedOffset;

            // 1. Сначала удаляем якорь из URL
            if (history.replaceState) {
                history.replaceState(null, null, window.location.pathname + window.location.search);
            }

            window.scrollTo({
                top: offsetPosition + offset,
                behavior: 'smooth',
            });

            setTimeout(() => {
                smoothScrollActive = false;
                // 2. На всякий случай повторно удаляем, если браузер восстановил якорь
                if (window.location.hash) {
                    history.replaceState(null, null, window.location.pathname + window.location.search);
                }
            }, 600);
        }
    }


    // ----- Имитация смены контента при клике на пункты меню (демо-функция) -----
    function updateContent(pageId)
    {
        scrollToSection(pageId);

    }

    // Обработчик кликов по навигации: закрываем меню и обновляем контент + активный класс
    navLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const page = link.getAttribute('data-page');
            if (page) {
                updateContent(page);
            }

            // активируем стиль активного пункта
            navLinks.forEach(nav => nav.classList.remove('active'));
            link.classList.add('active');

            // Закрываем меню после выбора раздела (опционально - приятный UX)
            closeMenu();
        });
    });

    // легкий фикс для закрытия при свайпе влево на тач-устройствах (необязательно, но приятно)
    let touchStartX = 0;
    sideMenu.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
    });
    sideMenu.addEventListener('touchmove', (e) => {
        const moveX = e.touches[0].clientX;
        if (moveX < touchStartX - 40 && sideMenu.classList.contains('open')) {
            closeMenu();
        }
    });

    // Имитация выхода (иконка выхода)
    const logoutIcon = document.getElementById('logoutIcon');
    if (logoutIcon) {
        logoutIcon.addEventListener('click', () => {

            closeMenu();
        });
    }

    // дополнительная адаптация: если меню открыто, а ресайз - оставляем корректное поведение.
    window.addEventListener('resize', () => {
        if (window.innerWidth > 992 && sideMenu.classList.contains('open')) {
            // не закрываем, но сохраняем позицию (ничего не делаем)
        }
    });

    // начальная инициализация (контент главной)
    // updateContent('dashboard');

    // Добавить обработчик
    const buyButtons = document.querySelectorAll('[data-buy-id]');

    if (buyButtons) {
        buyButtons.forEach(button => {
            button.addEventListener('click', function(e) {
                e.preventDefault();

                let form = document.getElementById('form-buy');
                let HtmlContent = form.innerHTML;

                const productId = e.currentTarget.getAttribute('data-buy-id');

                PopupUtils.loadHtmlContent(HtmlContent, {
                    title: 'Заказать товар',
                    type: 'content',
                    size: 'xl',
                    buttons: [],
                    onLoadSuccess: (html) => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(html, 'text/html');

                        // Находим все формы в загруженном HTML
                        const forms = doc.querySelectorAll('form');

                        if (forms.length === 0) {
                            console.warn('Формы не найдены в загруженном HTML');
                            return;
                        }

                        // Инициализируем каждую форму
                        forms.forEach((formElement, index) => {
                            const formId = formElement.id = `form-${index}`
                            const initForms = () => {
                                const domForms = document.querySelectorAll('.modal-body form');

                                if (domForms.length === 0) {
                                   // console.log('Формы еще не в DOM, повторная проверка...');
                                    setTimeout(initForms, 300);
                                    return;
                                }

                                domForms.forEach((domForm, index) => {
                                    // Присваиваем ID, если его нет
                                    if (!domForm.id) {
                                        domForm.id = `form-${index}`;
                                    }

                                    const formId = domForm.id;

                                    try {

                                        if (productId) {
                                            let input = domForm.querySelector('input[name="product_id"]');

                                            if (input) {
                                                input.value = productId;
                                            } else {
                                                input = document.createElement('input');
                                                input.type = 'hidden';
                                                input.name = 'product_id';
                                                input.value = productId;
                                                domForm.appendChild(input);
                                            }
                                        }
                                        
                                        const form = new FormBase(domForm, {
                                            endpoint: 'https://gearhive.ru/ajax/forms.php',
                                        });
                                        

                                        window.forms = window.forms || {};
                                        window.forms[formId] = form;

                                        //console.log(`Форма "${formId}" успешно инициализирована`);
                                    } catch (error) {
                                        console.error(`Ошибка инициализации формы "${formId}":`, error);
                                    }
                                });
                            };

                            // Начинаем инициализацию с небольшой задержкой
                            setTimeout(initForms, 200);
                        });
                    },
                    onLoadError: (error) => {
                        console.error('Ошибка:', error);
                    },
                });
            });
        });
    }

    // Карта


    // Проверяем, существует ли контейнер
    const mapContainer = document.getElementById('contact-map');

    if (!mapContainer) {
        console.error('Элемент с id="contactMap" не найден на странице');
        return;
    }

    // Загружаем карту
    ymaps.load('https://api-maps.yandex.ru/2.1/?apikey=8204e324-bd19-485d-845e-f61478cfbf89&lang&lang=ru_RU').then(maps => {
        const map = new maps.Map('contact-map', {
            center: [55.967496, 37.837615],  // [широта, долгота] для Бали
            zoom: 14,
            controls: ['zoomControl', 'fullscreenControl'],  // опционально
        });

        // Добавляем маркер (опционально)
        const placemark = new maps.Placemark([55.967496, 37.837615], {
                hintContent: 'Gearhive',
                balloonContent: `
                        <div style="text-align: center;">
                            <img src="https://gearhive.ru/_build/theme/assets/images/_logo.svg" 
                                 style="max-height: 40px; margin-bottom: 10px;">
                            <h4>Gearhive</h4>
                            <p>Автоматика для ворот</p>
                            <p>г. Пушкино,<br>ул. Боткинская, 33с4</p>
                            <a href="https://gearhive.ru" target="_blank">gearhive.ru</a>
                        </div>
                    `,

            },
            {
                iconLayout: 'default#image',
                iconImageHref: 'https://gearhive.ru/_build/theme/assets/images/_logo_placemark.svg',
                iconImageSize: [60, 60],
                iconImageOffset: [-22, -45],
            },
        );

        map.geoObjects.add(placemark);

        console.log('Карта успешно загружена');
    }).catch(error => {
        console.error('Ошибка загрузки карты:', error);
    });

    const btn = document.createElement('button');
    btn.textContent = '↑';
    btn.style.cssText = 'position:fixed;bottom:20px;left:20px; width:60px;height:60px;border-radius:50px;color:#fff; border:0; background:rgba(255, 255, 255, 0.6)';

    btn.innerHTML = `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 19V5M5 12L12 5L19 12" fill="rgba(255, 132, 0, 1)"/>
        </svg>`;

    document.body.appendChild(btn);
    btn.onclick = () => window.scrollTo(0, 0);
    window.onscroll = () => btn.style.display = window.scrollY > 600 ? 'block' : 'none';

});




